<template>
  <div class="partners-section">
    <div class="container text-center mb-4" style="font-size: 1.5rem; font-weight: 500; color: #2c3e50;">{{ comp.task }}</div>
    <div class="partners-container">
      <div class="partner-item" v-for="partner in partners" :key="partner.id">
        <div class="logo-container">
          <img :src="partner.logo" :alt="partner.name" class="partner-logo" />
        </div>
        <div class="partner-text">
          {{ partner.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePartners",
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      partners: [
        {
          id: 1,
          name: "МОНГОЛЫН ГАЗАР ЗОХИОН БАЙГУУЛАЛТЫН ХОЛБОО НҮТББ",
          logo: "https://res.gosmart.mn/apps/egazar/gzbh.jpg"
        },
        {
          id: 2,
          name: "МОНГОЛЫН ГЕОДЕЗИ, ФОТОГРАММЕТР, ЗУРАГ ЗҮЙН ХОЛБОО НҮТББ",
          logo: "https://res.gosmart.mn/apps/egazar/mgph.png"
        },
        {
          id: 3,
          name: "МОНГОЛЫН ГАЗРЫН МЕНЕЖМЕНТИЙН НЭГДСЭН ЭВСЭЛ НҮТББ",
          logo: "https://res.gosmart.mn/apps/egazar/evsel.png"
        },
        
        {
          id: 4,
          name: "МОНГОЛЫН КАДАСТРЫН ХОЛБОО НҮТББ",
          logo: "https://res.gosmart.mn/apps/egazar/mkh.jpg"
        }
      ]
    };
  },

  methods: {},

  mounted() {}
};
</script>

<style scoped>
.partners-section {
  padding: 60px 0;
  background-color: #f8f9fa;
}

.partners-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.logo-container {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.logo-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.partner-logo {
  max-width: 80px;
  max-height: 80px;
  object-fit: contain;
}

.partner-text {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  max-width: 200px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive design */
@media (max-width: 1024px) {
  .partners-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .partners-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 15px;
  }

  .logo-container {
    width: 100px;
    height: 100px;
  }

  .partner-logo {
    max-width: 60px;
    max-height: 60px;
  }

  .partner-text {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .partners-container {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .partners-section {
    padding: 40px 0;
  }
}
</style>
